import {
    alpine,
    blue,
    cyan,
    khaki,
    green,
    pink,
    orange,
    purple,
    red,
    yellow,
    grey,
    white
} from './newColors';

export const semanticColors = {
    surface: {
        page: grey[50],
        container: white,
        containerHover: grey[50],
        containerPressed: grey[100],
        containerInverted: grey[900],
        containerInvertedHover: grey[800],
        containerInvertedPressed: grey[700],
        item: white,
        itemHover: grey[50],
        itemPressed: grey[100],
        itemSelected: grey[100],
        itemSelectedHover: grey[200],
        itemSelectedPressed: grey[300],
        itemInset: grey[50],
        itemInsetHover: grey[100],
        itemInsetPressed: grey[200],
        itemStrong: grey[300],
        itemStrongHover: grey[400],
        itemStrongPressed: grey[500],
        disabled: grey[200],
        disabledInverted: grey[300],
        itemInverted: grey[900],
        itemInvertedHover: grey[800],
        itemInvertedPressed: grey[700],
        track: grey[500],
        neutral: grey[100],
        neutralHover: grey[200],
        neutralPressed: grey[300],
        accent: blue[50],
        accentHover: blue[100],
        accentPressed: blue[200],
        danger: red[50],
        dangerHover: red[100],
        dangerPressed: red[200],
        warning: orange[50],
        warningHover: orange[100],
        warningPressed: orange[200],
        success: green[50],
        successHover: green[100],
        successPressed: green[200],
        upgrade: alpine[50],
        upgradeHover: alpine[100],
        upgradePressed: alpine[200],
        cyan: cyan[50],
        cyanHover: cyan[100],
        cyanPressed: cyan[200],
        khaki: khaki[50],
        khakiHover: khaki[100],
        khakiPressed: khaki[200],
        pink: pink[50],
        pinkHover: pink[100],
        pinkPressed: pink[200],
        purple: purple[50],
        purpleHover: purple[100],
        purplePressed: purple[200],
        yellow: yellow[50],
        yellowHover: yellow[100],
        yellowPressed: yellow[200],
        red: red[50],
        redHover: red[100],
        redPressed: red[200],
        orange: orange[50],
        orangeHover: orange[100],
        orangePressed: orange[200],
        green: green[50],
        greenHover: green[100],
        greenPressed: green[200],
        blue: blue[50],
        blueHover: blue[100],
        bluePressed: blue[200],
        ai: purple[50],
        aiHover: purple[100],
        aiPressed: purple[200]
    },

    text: {
        primary: grey[900],
        secondary: grey[700],
        tertiary: grey[600],
        disabled: grey[400],
        accent: blue[600],
        accentHover: blue[700],
        danger: red[600],
        dangerHover: red[700],
        success: green[600],
        successHover: green[700],
        warning: orange[600],
        warningHover: orange[700],
        upgrade: alpine[600],
        upgradeHover: alpine[700],
        invertedPrimary: white,
        invertedSecondary: grey[100],
        invertedTertiary: grey[200],
        invertedDisabled: grey[500],
        cyan: cyan[600],
        khaki: khaki[600],
        pink: pink[600],
        purple: purple[600],
        yellow: yellow[600],
        red: red[600],
        orange: orange[600],
        green: green[600],
        blue: blue[600]
    },

    stroke: {
        primary: grey[400],
        secondary: grey[200],
        tertiary: grey[50],
        disabled: grey[200],
        selected: grey[900],
        selectedDisabled: grey[400],
        focus: grey[900],
        keyboardFocus: purple[500],
        accent: blue[400],
        accentSecondary: blue[300],
        danger: red[400],
        dangerSecondary: red[300],
        warning: orange[400],
        warningSecondary: orange[300],
        success: green[400],
        successSecondary: green[300],
        upgrade: alpine[400],
        upgradeSecondary: alpine[300],
        blue: blue[400],
        blueSecondary: blue[300],
        blueTertiary: blue[200],
        green: green[400],
        greenSecondary: green[300],
        greenTertiary: green[200],
        red: red[400],
        redSecondary: red[300],
        redTertiary: red[200],
        orange: orange[400],
        orangeSecondary: orange[300],
        orangeTertiary: orange[200],
        cyan: cyan[400],
        cyanSecondary: cyan[300],
        khaki: khaki[400],
        khakiSecondary: khaki[300],
        pink: pink[400],
        pinkSecondary: pink[300],
        purple: purple[400],
        purpleSecondary: purple[300],
        yellow: yellow[400],
        yellowSecondary: yellow[300],
        dangerTertiary: red[200],
        warningTertiary: orange[200],
        yellowTertiary: yellow[200],
        successTertiary: green[200],
        upgradeTertiary: alpine[200],
        khakiTertiary: khaki[200],
        cyanTertiary: cyan[200],
        accentTertiary: blue[200],
        purpleTertiary: purple[200],
        pinkTertiary: pink[200],
        ai: purple[400],
        aiSecondary: purple[300],
        aiTertiary: purple[200]
    },

    base: {
        accent: blue[500],
        accentHover: blue[600],
        accentPressed: blue[700],
        neutral: grey[500],
        neutralHover: grey[600],
        neutralPressed: grey[700],
        danger: red[500],
        dangerHover: red[600],
        dangerPressed: red[700],
        warning: orange[500],
        warningHover: orange[600],
        warningPressed: orange[700],
        success: green[500],
        successHover: green[600],
        successPressed: green[700],
        upgrade: alpine[500],
        upgradeHover: alpine[600],
        upgradePressed: alpine[700],
        cyan: cyan[500],
        cyanHover: cyan[600],
        cyanPressed: cyan[700],
        khaki: khaki[500],
        khakiHover: khaki[600],
        khakiPressed: khaki[700],
        pink: pink[500],
        pinkHover: pink[600],
        pinkPressed: pink[700],
        purple: purple[500],
        purpleHover: purple[600],
        purplePressed: purple[700],
        yellow: yellow[500],
        yellowHover: yellow[600],
        yellowPressed: yellow[700]
    },

    brand: {
        ai: purple[700],
        aiSubtle: purple[500]
    }
};
